import {useTranslation} from 'react-i18next';

export const useCommonTagPickerTranslations = () => {
	return useTranslation('common/tagPickers');
};
